import {
  ReactNode,
  createContext,
  useCallback,
  useContext,
  useMemo,
} from 'react'
import { ExtraContentsContext } from './ExtraContentsContext'
import { LessonExtraContentsContext } from './LessonExtraContentsContext'
import { ModulesContext } from './ModulesContext'

interface ICourseContextsResetContext {
  resetAllContexts: () => void
}

export const CourseContextsResetContext =
  createContext<ICourseContextsResetContext>({
    resetAllContexts: () => {},
  })

export function CourseContextsResetProvider({
  children,
}: {
  children: ReactNode
}) {
  const { resetExtraContents } = useContext(ExtraContentsContext)
  const { resetLessonExtraContents } = useContext(LessonExtraContentsContext)
  const { resetModules } = useContext(ModulesContext)

  const resetAllContexts = useCallback(() => {
    resetExtraContents?.()
    resetLessonExtraContents?.()
    resetModules?.()
  }, [resetExtraContents, resetLessonExtraContents, resetModules])

  const contextValue = useMemo(() => ({ resetAllContexts }), [resetAllContexts])

  return (
    <CourseContextsResetContext.Provider value={contextValue}>
      {children}
    </CourseContextsResetContext.Provider>
  )
}
